/**
 * Domain constants, deliberately kept in a **leaf module that reads nothing from `process.env`**.
 *
 * The CLI bootstrap (`@sigma/project/init.js`) needs the top-level domain to validate the git
 * user's email, and it is also what populates `process.env.USERNAME` / `WORKTREE_NAME`. Since a
 * module's static import graph is evaluated before its own body, anything the bootstrap imports
 * must not reach `./environments.js` — that module snapshots those variables into consts the
 * moment it evaluates, and an early snapshot silently degrades every `bun sigma` to
 * `WORKTREE_NAME='sigma'` / `USERNAME='undefined'`. Keep this file dependency-free.
 */
/** The top-level domain the whole product is served from and addressed at. */
export const DOMAIN_TOP_LEVEL = 'healed.care';
//# sourceMappingURL=domains.js.map